import { ROLLOUTS } from '../../types/rollouts';
import { manageRecentlyViewed } from './guestPageViews';

/**
 * Activate the page view management logic for users behind the rollout
 */
export const managePageViews = async(rollouts, gigId, pathfinderWrapper) => {
    const shouldManagePageViews = rollouts[ROLLOUTS.CHAM_V5_GIG_PAGE_VIEWS_FLOW];

    if (shouldManagePageViews) {
        manageRecentlyViewed(gigId, pathfinderWrapper);
    }
};
